export async function redirectLocalHttps(location: { protocol: string; hostname: string; pathname?: string; hash?:string; replace(url: string): void }, fetchImpl: typeof fetch = fetch) {
  if (location.protocol !== "http:" || !["localhost", "127.0.0.1", "[::1]"].includes(location.hostname)) return false;
  try {
    const response = await fetchImpl("/api/local-https-entry", { cache: "no-store", credentials: "omit", redirect: "error", signal: AbortSignal.timeout(3000) });
    if (!response.ok) return false;
    const { port } = await response.json();
    if (!Number.isInteger(port) || port < 1 || port > 65535) return false;
    const path = location.pathname?.replace(/\/$/, "") === "/customer-chat-test" ? "/customer-chat-test" : "/";
    const testHash=path==="/customer-chat-test" && /^#testToken=[A-Za-z0-9_-]{43}$/.test(location.hash||"")?location.hash:"";
    location.replace(`https://127.0.0.1:${port}${path}${testHash}`);
    return true;
  } catch { return false; }
}
